const ATERA_API_DOCUMENTATION_URL =
    'https://support.atera.com/hc/en-us/articles/219083397-APIs';

const ATERA_SCRIPT_DOCUMENTATION_URL =
    'https://support.atera.com/hc/en-us/articles/235215188-Create-or-Upload-Scripts';

export { ATERA_API_DOCUMENTATION_URL, ATERA_SCRIPT_DOCUMENTATION_URL };
